// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root {
  --color-01: #7bc932;
  --color-02: #ffec29;
  --color-03: #ffbf3e;
  --color-04: #fd6841;
  --color-no-data: #bcbcbc;
  --green: #82bc00;
  --greenDark: #699900;
  --greenSelected: #4E7300;
  --yellow: #FAC239;
  --yellowDark: #faa800;
  --yellowSelected: #D48D00;
  --red: #e40039;
  --redDark: #B0002C;
  --redSelected: #7D001F;
  --blue: #00a1e0;
  --blueDark: #002b59;
}

/* Komponenta pro vyhledávání */
.search-input {
  width: 100%;
  max-width: 450px;
  /* input */
  /* checkbox */
}
.search-input .input-group {
  width: 100%;
  padding-inline: 10px;
  display: flex;
  justify-content: center;
}
.search-input .input-group .search-input-field {
  flex: 1 1 auto;
  min-width: 0;
}
.search-input .input-group .search-input-field .form-control {
  width: 100%;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.search-input .input-group .search-input-submit {
  flex: 0 0 auto;
}
.search-input .input-group .search-input-submit .btn {
  background: var(--secondaryColor);
  color: white;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  white-space: nowrap;
}
.search-input .input-group .search-input-submit .btn:hover {
  filter: brightness(1.75);
}
.search-input .search-input-filters {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
.search-input .search-input-filters .form-check-input:checked {
  background-color: var(--secondaryColor);
  border-color: var(--secondaryColor);
}

/* Úprava komponenty datagridu na stránce vyhledávání */
.datagrid.search-page-datagrid {
  margin-top: 15px !important;
  margin-bottom: 15px !important;
  background: white;
  border-radius: 1rem !important;
}
.datagrid.search-page-datagrid h5 {
  color: var(--primaryColor);
  font-size: 2rem !important;
}
.datagrid.search-page-datagrid table {
  border: 5px solid white;
  border-radius: 25px;
}
.datagrid.search-page-datagrid table th {
  background: var(--secondaryColor);
  color: white;
}
.datagrid.search-page-datagrid .active > .page-link {
  background: var(--secondaryColor);
  border: 1px solid var(--secondaryColor);
}

/* #region Favorites (Oblíbené záložky)*/
/* ikonka hvězdičky v tabpanelu */
.favorites, .languages {
  font-size: 18px;
  cursor: pointer;
}
.favorites:hover, .languages:hover {
  color: var(--secondaryColor);
}

/* obsah panelu s položkami */
.favorites-content, .languages-content {
  position: absolute;
  top: 0px;
  right: 0px;
  transform: translate(0px, 30px);
  margin: 5px;
  padding: 10px;
  border-radius: 5px;
  background-color: white;
  color: black;
  max-height: 400px;
  min-width: 100px;
  z-index: 10000;
  overflow-y: auto;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  border-top-width: 0;
  border-bottom-width: 1px;
  /*záznam oblíbené položky*/
  /*nový záznam*/
}
.favorites-content .item, .languages-content .item {
  min-width: 150px;
  padding: 1.5px;
}
.favorites-content .item .icon, .languages-content .item .icon {
  float: right;
  color: var(--primaryColor);
}
.favorites-content .item .icon:hover, .languages-content .item .icon:hover {
  color: var(--secondaryColor);
}
.favorites-content .item .link, .languages-content .item .link {
  text-decoration: none;
  margin-right: 5px;
  font-size: 0.8rem;
  line-height: normal;
  color: black;
}
.favorites-content .item .link:hover, .languages-content .item .link:hover {
  color: var(--secondaryColor);
}
.favorites-content .item.new, .languages-content .item.new {
  border-bottom: 1px solid var(--bs-border-color);
}
.favorites-content .item.new:hover, .languages-content .item.new:hover {
  color: var(--secondaryColor);
}

/* #endregion Favorites (Oblíbené záložky) */
/* #region Languages (Výběr jazyka) */
.languages {
  /* Ikona vlajky v tabpanelu */
  /* Obsah panelu s jazyky */
}
.languages #imgFlag {
  border: 1px solid transparent;
  border-radius: 2px;
}
.languages #imgFlag:hover {
  outline: solid 1px var(--secondaryColor);
}
.languages .languages-content .item {
  min-width: 80px;
  padding: 1.5px;
  cursor: pointer;
  padding: 2px 10px 2px 10px;
  background: var(--primaryColor);
  border-radius: 5px;
  color: white;
}
.languages .languages-content .item:hover {
  background: var(--secondaryColor);
}

/* #endregion Languages (Výběr jazyka) */
`, "",{"version":3,"sources":["webpack://./wwwroot/css/Mobile.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,oBAAoB;EACpB,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,aAAa;AACf;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,WAAW;EACX,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;EACE,cAAc;AAChB;AACA;EACE,iCAAiC;EACjC,YAAY;EACZ,yBAAyB;EACzB,4BAA4B;EAC5B,4BAA4B;EAC5B,+BAA+B;EAC/B,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA,uDAAuD;AACvD;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,iBAAiB;EACjB,8BAA8B;AAChC;AACA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,iCAAiC;EACjC,YAAY;AACd;AACA;EACE,iCAAiC;EACjC,uCAAuC;AACzC;;AAEA,wCAAwC;AACxC,iCAAiC;AACjC;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,4BAA4B;AAC9B;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,+BAA+B;EAC/B,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,wBAAwB;EACxB,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,0BAA0B;AAC5B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,+CAA+C;AACjD;AACA;EACE,4BAA4B;AAC9B;;AAEA,4CAA4C;AAC5C,qCAAqC;AACrC;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,iCAAiC;AACnC;;AAEA,wCAAwC","sourcesContent":["@charset \"UTF-8\";\r\n:root {\r\n  --color-01: #7bc932;\r\n  --color-02: #ffec29;\r\n  --color-03: #ffbf3e;\r\n  --color-04: #fd6841;\r\n  --color-no-data: #bcbcbc;\r\n  --green: #82bc00;\r\n  --greenDark: #699900;\r\n  --greenSelected: #4E7300;\r\n  --yellow: #FAC239;\r\n  --yellowDark: #faa800;\r\n  --yellowSelected: #D48D00;\r\n  --red: #e40039;\r\n  --redDark: #B0002C;\r\n  --redSelected: #7D001F;\r\n  --blue: #00a1e0;\r\n  --blueDark: #002b59;\r\n}\r\n\r\n/* Komponenta pro vyhledávání */\r\n.search-input {\r\n  width: 100%;\r\n  max-width: 450px;\r\n  /* input */\r\n  /* checkbox */\r\n}\r\n.search-input .input-group {\r\n  width: 100%;\r\n  padding-inline: 10px;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.search-input .input-group .search-input-field {\r\n  flex: 1 1 auto;\r\n  min-width: 0;\r\n}\r\n.search-input .input-group .search-input-field .form-control {\r\n  width: 100%;\r\n  border-top-right-radius: 0px;\r\n  border-bottom-right-radius: 0px;\r\n}\r\n.search-input .input-group .search-input-submit {\r\n  flex: 0 0 auto;\r\n}\r\n.search-input .input-group .search-input-submit .btn {\r\n  background: var(--secondaryColor);\r\n  color: white;\r\n  border-top-left-radius: 0;\r\n  border-bottom-left-radius: 0;\r\n  border-top-right-radius: 5px;\r\n  border-bottom-right-radius: 5px;\r\n  white-space: nowrap;\r\n}\r\n.search-input .input-group .search-input-submit .btn:hover {\r\n  filter: brightness(1.75);\r\n}\r\n.search-input .search-input-filters {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-top: 10px;\r\n}\r\n.search-input .search-input-filters .form-check-input:checked {\r\n  background-color: var(--secondaryColor);\r\n  border-color: var(--secondaryColor);\r\n}\r\n\r\n/* Úprava komponenty datagridu na stránce vyhledávání */\r\n.datagrid.search-page-datagrid {\r\n  margin-top: 15px !important;\r\n  margin-bottom: 15px !important;\r\n  background: white;\r\n  border-radius: 1rem !important;\r\n}\r\n.datagrid.search-page-datagrid h5 {\r\n  color: var(--primaryColor);\r\n  font-size: 2rem !important;\r\n}\r\n.datagrid.search-page-datagrid table {\r\n  border: 5px solid white;\r\n  border-radius: 25px;\r\n}\r\n.datagrid.search-page-datagrid table th {\r\n  background: var(--secondaryColor);\r\n  color: white;\r\n}\r\n.datagrid.search-page-datagrid .active > .page-link {\r\n  background: var(--secondaryColor);\r\n  border: 1px solid var(--secondaryColor);\r\n}\r\n\r\n/* #region Favorites (Oblíbené záložky)*/\r\n/* ikonka hvězdičky v tabpanelu */\r\n.favorites, .languages {\r\n  font-size: 18px;\r\n  cursor: pointer;\r\n}\r\n.favorites:hover, .languages:hover {\r\n  color: var(--secondaryColor);\r\n}\r\n\r\n/* obsah panelu s položkami */\r\n.favorites-content, .languages-content {\r\n  position: absolute;\r\n  top: 0px;\r\n  right: 0px;\r\n  transform: translate(0px, 30px);\r\n  margin: 5px;\r\n  padding: 10px;\r\n  border-radius: 5px;\r\n  background-color: white;\r\n  color: black;\r\n  max-height: 400px;\r\n  min-width: 100px;\r\n  z-index: 10000;\r\n  overflow-y: auto;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\r\n  border-top-width: 0;\r\n  border-bottom-width: 1px;\r\n  /*záznam oblíbené položky*/\r\n  /*nový záznam*/\r\n}\r\n.favorites-content .item, .languages-content .item {\r\n  min-width: 150px;\r\n  padding: 1.5px;\r\n}\r\n.favorites-content .item .icon, .languages-content .item .icon {\r\n  float: right;\r\n  color: var(--primaryColor);\r\n}\r\n.favorites-content .item .icon:hover, .languages-content .item .icon:hover {\r\n  color: var(--secondaryColor);\r\n}\r\n.favorites-content .item .link, .languages-content .item .link {\r\n  text-decoration: none;\r\n  margin-right: 5px;\r\n  font-size: 0.8rem;\r\n  line-height: normal;\r\n  color: black;\r\n}\r\n.favorites-content .item .link:hover, .languages-content .item .link:hover {\r\n  color: var(--secondaryColor);\r\n}\r\n.favorites-content .item.new, .languages-content .item.new {\r\n  border-bottom: 1px solid var(--bs-border-color);\r\n}\r\n.favorites-content .item.new:hover, .languages-content .item.new:hover {\r\n  color: var(--secondaryColor);\r\n}\r\n\r\n/* #endregion Favorites (Oblíbené záložky) */\r\n/* #region Languages (Výběr jazyka) */\r\n.languages {\r\n  /* Ikona vlajky v tabpanelu */\r\n  /* Obsah panelu s jazyky */\r\n}\r\n.languages #imgFlag {\r\n  border: 1px solid transparent;\r\n  border-radius: 2px;\r\n}\r\n.languages #imgFlag:hover {\r\n  outline: solid 1px var(--secondaryColor);\r\n}\r\n.languages .languages-content .item {\r\n  min-width: 80px;\r\n  padding: 1.5px;\r\n  cursor: pointer;\r\n  padding: 2px 10px 2px 10px;\r\n  background: var(--primaryColor);\r\n  border-radius: 5px;\r\n  color: white;\r\n}\r\n.languages .languages-content .item:hover {\r\n  background: var(--secondaryColor);\r\n}\r\n\r\n/* #endregion Languages (Výběr jazyka) */\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
